import * as React from 'react'
import BaseIcon from 'react-icon-base'
import { IIconProps } from './interface'
import { EColors } from 'app/constants/colors'

const ToastrCloseIcon = (props: IIconProps) => (
  <BaseIcon width="34" height="34" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="translate(0 .25)" fill="none" fillRule="evenodd">
      <circle fill={EColors.WHITE} cx="16.25" cy="16.25" r="16.25" />
      <g stroke={EColors.LIGHT_RED} strokeWidth="2.43">
        <path d="m10.665 21.284 11.091-11.09M21.835 21.284l-11.091-11.09" />
      </g>
    </g>
  </BaseIcon>
)

export default ToastrCloseIcon
